var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.416 12.232 17 15.816 15.816 17l-3.584-3.584a7.498 7.498 0 0 1-4.7 1.648A7.534 7.534 0 0 1 0 7.532 7.534 7.534 0 0 1 7.532 0a7.534 7.534 0 0 1 7.532 7.532 7.498 7.498 0 0 1-1.648 4.7zm-1.679-.62a5.839 5.839 0 0 0 1.653-4.08 5.856 5.856 0 0 0-5.858-5.858 5.856 5.856 0 0 0-5.858 5.858 5.856 5.856 0 0 0 5.858 5.858 5.839 5.839 0 0 0 4.08-1.653l.125-.126z",
    fill: "#222",
    fillRule: "nonzero"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic-search.a1c5704e2d0d3e08558c645efa7e043d.svg";
export { ForwardRef as ReactComponent };